export default {
  YOUR_EVENTS: 'Ihre Events',
  ADD_EVENTS: 'Ereignis hinzufügen',
  NO_EVENTS: 'Sie haben noch keine Events hinzugefügt!',
  ENTER: 'Eingabe',
  EVENT_NAME: 'Ereignisname',
  START_DATE: 'Startdatum',
  END_DATE: 'Enddatum',
  LOCATION: 'Standort',
  TIMEZONE: 'Zeitzone',
  EVENT_CONFIG: 'Ereigniskonfiguration',
  API_KEY: 'API Schlüssel',
  ARCHIVE_DAYS: 'Archivtage',
  ARCHIVE_DAYS_LABEL: 'Tage zum Archivieren nach Eventende',
  GDPR_CONFIG: 'GDPR -Konfiguration',
  GDPR_CONSENT: 'Einwilligung zur GDPR',
  GDPR_TITLE: 'GDPR -Titel',
  GDPR_DESC: 'GDPR Beschreibung',
  GDPR_APPROVE_LABEL: 'GDPR Beschriftung der Schaltfläche Genehmigen',
  GDPR_CANCEL_LABEL: 'GDPR Abbrechen Schaltflächenbeschriftung',
  ADD_EVENT: 'Ereignis hinzufügen',
  ADD_EVENT_SUCCESS: 'Ihr Event wurde erfolgreich erstellt!'
}
